export default __webpack_public_path__ + "locales/fi/ChangePortalOwner.json?hash=7807f546e3bc46fffe35a7f6a80010f9";